import { useEffect } from 'react'
import { NavLink } from 'react-router-dom'

import themeConfig from '@configs/themeConfig'
import {useSkin} from "../../../../../utility/hooks/useSkin"

const VerticalMenuHeader = props => {
  const { menuCollapsed, setGroupOpen, menuHover } = props
  const { skin } = useSkin()


  useEffect(() => {
    if (!menuHover && menuCollapsed) setGroupOpen([])
  }, [menuHover, menuCollapsed])

  return (
    <div className='navbar-header'>
      <NavLink to='/' className='navbar-brand'>
        <span className='brand-logo mt-1'>
          <a href={'/'}><img width={133} height={30}  src={skin === 'light' ? themeConfig.app.appLogoCollapsed : themeConfig.app.appLogoCollapsedDarkMode} alt='logo' /></a>
        </span>
        <h2 className='brand-text mb-0'>{themeConfig.app.appName}</h2>
      </NavLink>
    </div>
  )
}

export default VerticalMenuHeader
